export class Helpers {
  public static isBlank(value: any): boolean {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === 'string' && value === '') {
      return true;
    }

    if (value === 0) {
      return true;
    }

    return false;
  }

  public static isPresent(value: any): boolean {
    return !this.isBlank(value);
  }

  /**
   * accepts a value and options and formats the number accordingly.
   *
   * @param value[number | string | null]
   * @param defaultValue [number | string | undefined] the value to return when value isn't able to be formatted.
   * @param precision [number]  if included will format the output as a float to {precision} decimal places
   */
  public static seraphNumberFormatter(
    value: number | string | null,
    defaultValue: number | string | undefined = undefined,
    precision: number | undefined = undefined
  ): string {

    let formatConfig: Record<string, any> = {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    };

    if (typeof defaultValue === typeof undefined) {
      defaultValue = 0;
    }

    if (value == null) {
      return defaultValue as string;
    }

    if (typeof value === 'string') {
      value = parseFloat(value.replace(',', ''));
    }

    if (isNaN(value)) {
      return defaultValue as string;
    }

    if (typeof precision !== typeof undefined) {
      if (isNaN(precision)) {
        precision = 0;
      }

      formatConfig = {
        style: 'decimal',
        minimumIntegerDigits: 1,
        minimumFractionDigits: precision,
        maximumFractionDigits: precision
      };
    }

    return value.toLocaleString('en-GB', formatConfig);
  }

  /**
   * accepts a value and options and formats a number as currency with the correct iso code prefixed
   *
   * @param value [number | string | null]
   * @param currency [string|{ iso_code: string }]
   * @param defaultValue [number | string | undefined]
   */
  public static currencyFormatter(
    value: number | string | null,
    currency: string | { iso_code: string },
    defaultValue: number | string | undefined = undefined,
    precision = 2
  ): string {

    if (typeof defaultValue === typeof undefined) {
      defaultValue = '';
    }

    let s: string = this.seraphNumberFormatter(value, defaultValue, precision);

    if (typeof currency === 'string') {
      return `${currency}\xA0${s}`;
    } else {
      return `${currency.iso_code}\xA0${s}`;
    }
  }


  /**
   * accepts a value and options and formats a number as currency with the correct symbol so long as the currency is supported
   *
   * @param value [number | string | null]
   * @param currency [string|{ iso_code: string }]
   * @param defaultValue [number | string]
   */
  public static currencyFormatterWithSymbol(
    value: number | string | null,
    currency: string | { iso_code: string },
    defaultValue: number | string = '',
    precision = 2
  ): string {

    const s: string = this.seraphNumberFormatter(value, defaultValue, precision);
    const input = typeof currency === 'string' ? currency : currency.iso_code;

    if (['GBP', '£'].includes(input.toUpperCase())) {
      return `£${s}`;
    } else if (['EUR', '€'].includes(input.toUpperCase())) {
      return `${s}€`;
    } else if (['USD', '$'].includes(input.toUpperCase())) {
      return `$${s}`;
    } else if (['AUD', '$'].includes(input.toUpperCase())) {
      return `$${s}`;
    } else {
      console.warn('Currency not supported');
      return `${input}${s}`;
    }

  }
}
